/**
 * Après un PUT réussi par un admin, le serveur envoie déjà la notification au vendeur (vendorNotified).
 * Cette fonction reste le point d’extension côté client (analytics, futur endpoint dédié).
 *
 * @param {string} vehicleId
 * @returns {Promise<{ ok: boolean }>}
 */
export async function sendAdminUpdateNotification(vehicleId) {
  if (vehicleId == null || vehicleId === '') {
    return { ok: false };
  }
  return { ok: true };
}
